module.exports = __webpack_public_path__ + "img/4eb4e63.png";